export default __webpack_public_path__ + "static/thumb-14-2e63ad198e4513265b0f83bf4c264ab4.jpg";